import { network } from 'services/network';

export const ENDPOINT = 'api/bo/getCurrentSPI';

export const getCurrentSPI = (params) => {
    return network.post(ENDPOINT, params).then((response) => response.data);
};
